import {BusinessAccountPurpose, BusinessAccountPurposeMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableBusinessAccountPurposeProps {
	accountPurpose?: BusinessAccountPurpose
	setAccountPurpose: (value: BusinessAccountPurpose) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: BusinessAccountPurpose) => void
	className?: string
}

export function EditableBusinessAccountPurposeField(props: EditableBusinessAccountPurposeProps) {
	if (props.accountPurpose) {
		return (
			<Editable
				label="Account Purpose"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setAccountPurpose}
				value={props.accountPurpose}
				initial={props.accountPurpose}
				update={props.update}
				className={props.className}
				possibleValues={BusinessAccountPurposeMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
